module.exports = __webpack_public_path__ + "img/member.6bc0cb13.svg";